export default "/images/vendor/flag-icons/flags/1x1/im.svg?cbaa28108b60592ee8f32a36363e5afe";